export default "__VITE_ASSET__DZ7yN4FC__"